import React from "react";
import Image from "react-bootstrap/Image";
import StudentController from "../api/StudentController";
import PersonView from "./PersonView";
import { Modal } from "react-bootstrap";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";

interface InstructorsViewProps
{
    subjectCode: string;
    subjectNumber: string;
    termCode: string;
}

interface InstructorsViewState
{
    data: Instructors;
    modalData: Person;
    showModal: boolean;
}

export default class InstructorsView extends React.Component<InstructorsViewProps, InstructorsViewState>
{
    studentController: StudentController;

    constructor(props: InstructorsViewProps)
    {
        super(props);
        this.studentController = new StudentController();

        this.state = {
            data: null,
            showModal: false,
            modalData: null
        };
    }

    async componentDidMount()
    {
        if (this.props.subjectCode && this.props.subjectNumber && this.props.termCode)
        {
            const data = await this.studentController.getInstructors(this.props.subjectCode, this.props.subjectNumber, this.props.termCode);
            this.setState({
                data: data
            });
        }
    }

    render(): React.ReactNode
    {
        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true, modalData: itm });
        };

        return <div>
            {
                (this.state.data && this.state.data.instructor)
                    ?
                    <a style={{ color: "#1C4B87" }} onClick={(): void => handleShow(this.state.data.instructor)}><PersonView data={this.state.data.instructor} /></a>
                    :
                    <b> - </b>
            }
            <Modal size={"sm"} centered show={this.state.showModal} onHide={handleClose}>
                <Modal.Body>
                    <ModalPersonRenderer data={this.state.modalData} />
                </Modal.Body>
            </Modal>
        </div>;
    }
}